export const TEAL       = "#069dae";
export const TEAL_DARK  = "#058a9a";
export const TEAL_LIGHT = "#e1f5ee";
export const GREEN      = "#4caf50";
export const GREEN_DARK = "#388e3c";
export const GREEN_LIGHT = "#f1f8e9";
 
export const modalStyle = {
  position: "absolute", top: "50%", left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper", border: "none", boxShadow: 24,
  borderRadius: 3, outline: "none",
};
 
export const thStyle = {
  fontWeight: 600, backgroundColor: TEAL, color: "#FFF", fontSize: 13,
};
 
export const PROD_SEARCH_COLUMNS = [
  { value: "product_name",    label: "Nama Produk" },
  { value: "product_id",      label: "Kode Produk"  },
  // { value: "category_master", label: "Kategori"     },
  // { value: "brand_master",    label: "Brand"        },
];
 
export const TOAST_CFG = {
  position: "top-right", autoClose: 4000, hideProgressBar: false,
  closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light",
};
 